import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { Button } from "bootstrap-4-react/lib/components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BatchPagination from "../batch/BatchPagination";
import LoaderSpinner from "../common/Loader";
import { numOfPage } from "../../constant";
import { getDropshipCatalog, getDropshipMarginConfig } from "../../store/actions/dropship.action";
import ImportModal from "./ImportModal";
import "./dropshipExplore.css";

export default function DropshipExplore() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { catalogList, catalogListStatus, catalogTotalRecords, marginConfigs } = useSelector(
        (state) => state.dropshipReducer
    );

    const globalMargin = marginConfigs?.find((c) => c.scope === "Global") || { flatAmount: 0, percentAmount: 0 };
    const marginFlat = Number.parseFloat(globalMargin.flatAmount) || 0;
    const marginPercent = Number.parseFloat(globalMargin.percentAmount) || 0;
    const computeBuyerCost = (wholesale) => {
        const w = Number.parseFloat(wholesale) || 0;
        return w + marginFlat + (w * marginPercent / 100);
    };

    const [searchTxt, setSearchTxt] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(30);
    const [showImportModal, setShowImportModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const loader = catalogListStatus === "PENDING";

    useEffect(() => {
        loadCatalog();
        dispatch(getDropshipMarginConfig({}));
    }, [currentPage, pageSize]);

    const loadCatalog = () => {
        dispatch(
            getDropshipCatalog({
                pageIndex: currentPage,
                pageSize: pageSize,
                searchkey: searchTxt || null,
            })
        );
    };

    const handleSearch = () => {
        setCurrentPage(1);
        loadCatalog();
    };

    const handleSearchKeyDown = (e) => {
        if (e.key === "Enter") handleSearch();
    };

    const handleClearSearch = () => {
        setSearchTxt("");
        setCurrentPage(1);
        dispatch(
            getDropshipCatalog({
                pageIndex: 1,
                pageSize: pageSize,
                searchkey: null,
            })
        );
    };

    const handleImportClick = (product) => {
        setSelectedProduct(product);
        setShowImportModal(true);
    };

    const handleImportSuccess = () => {
        loadCatalog();
    };

    const totalPages = Math.ceil(catalogTotalRecords / pageSize) || 1;

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    Explore Dropship Products
                    <div className="top_right_button_container">
                        <Button
                            className="cus-primary-transparent-btn"
                            onClick={() => navigate("/dropship-settings")}
                        >
                            Settings
                        </Button>
                    </div>
                </div>

                <div className="main_content_table incomingTbl">
                    {/* Search Bar */}
                    <div className="cus-page-search-sec" style={{ padding: "12px 16px" }}>
                        <div className="d-flex align-items-center gap-2">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by SKU or Product Name"
                                value={searchTxt}
                                onChange={(e) => setSearchTxt(e.target.value)}
                                onKeyDown={handleSearchKeyDown}
                                style={{ maxWidth: "350px" }}
                            />
                            <Button className="cus-seconday-bg-btn" onClick={handleSearch}>
                                Search
                            </Button>
                            {searchTxt && (
                                <Button className="cus-primary-transparent-btn" onClick={handleClearSearch}>
                                    Clear
                                </Button>
                            )}
                        </div>
                    </div>

                    {/* Loading */}
                    {loader && (
                        <div className="full-screen-spinner-overlay">
                            <LoaderSpinner />
                        </div>
                    )}

                    {/* Table */}
                    <div className="tableFixHead">
                        <Table className="table table-borderless">
                            <thead>
                                <tr>
                                    <th width="5%">#</th>
                                    <th width="8%">Image</th>
                                    <th width="15%">SKU</th>
                                    <th width="20%">Product Name</th>
                                    <th width="12%">Supplier</th>
                                    <th width="10%">Cost</th>
                                    <th width="8%">Available</th>
                                    <th width="8%">Shipping</th>
                                    <th width="8%">Fulfillment</th>
                                    <th width="6%">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!loader && catalogList.length === 0 && (
                                    <tr>
                                        <td colSpan="10" className="text-center py-4" style={{ color: "#999" }}>
                                            No products available for dropshipping.
                                        </td>
                                    </tr>
                                )}
                                {catalogList.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                                        <td>
                                            {item.imageUrl ? (
                                                <img
                                                    src={item.imageUrl}
                                                    alt={item.productName}
                                                    className="dropship-product-thumb"
                                                />
                                            ) : (
                                                <div className="dropship-no-image">
                                                    <i className="fa fa-image" />
                                                </div>
                                            )}
                                        </td>
                                        <td>{item.productSKU}</td>
                                        <td>{item.productName}</td>
                                        <td>Verified Supplier</td>
                                        <td>${computeBuyerCost(item.wholesalePrice).toFixed(2)}</td>
                                        <td>
                                            <span style={{ color: item.availableQuantity > 0 ? "#28a745" : "#dc3545", fontWeight: 600 }}>
                                                {item.availableQuantity}
                                            </span>
                                        </td>
                                        <td>{item.shippingPaidBy}</td>
                                        <td>{item.fulfillmentDays} days</td>
                                        <td>
                                            {item.alreadyImported ? (
                                                <span className="badge bg-secondary">Imported</span>
                                            ) : (
                                                <Button
                                                    className="cus-seconday-bg-btn btn-sm"
                                                    onClick={() => handleImportClick(item)}
                                                >
                                                    Import
                                                </Button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>

                    {/* Pagination */}
                    {catalogTotalRecords > 0 && (
                        <BatchPagination
                            gridData={catalogList}
                            numberOfPage={pageSize}
                            numOfPage={numOfPage}
                            loader={loader}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            totalRecords={catalogTotalRecords}
                            setCurrentPage={setCurrentPage}
                            setNumberOfPage={(val) => {
                                setPageSize(val);
                                setCurrentPage(1);
                            }}
                        />
                    )}
                </div>
            </div>

            {/* Import Modal (Day 5) */}
            {showImportModal && selectedProduct && (
                <ImportModal
                    show={showImportModal}
                    onHide={() => setShowImportModal(false)}
                    product={selectedProduct}
                    onSuccess={handleImportSuccess}
                />
            )}
        </main>
    );
}
